<template>
  <div
    class="total"
    :style="{
      width: num == 6 ? '80%' : '100%',
    }"
  >
    <div
      class="totalimg"
      v-for="(i, j) in senddata"
      :key="j"
      :style="{
        backgroundImage: `url(${i.url})`,
        width: types == 0 ? '17.45vw' : types == -1 ? '36.67vw' : '23.59vw',
        height: types == 0 ? '10.42vw' : types == -1 ? '21.88vw' : '14.06vw',
        // width: '17.45vw',
      }"
      @mouseenter="hover(j)"
      @mouseleave="hover(-1)"
      @click="turnto"
    >
      <div class="mask" v-if="movehover == j">
        {{ i.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["senddata"],
  data() {
    return {
      movehover: -1,
      types: 0,
      num: 6,
    };
  },
  mounted() {
    this.types = 0;
  },
  watch: {
    senddata(n, o) {
      if (n.length == 8) {
        this.types = 0;
        this.num = 8;
      } else if (n.length == 6) {
        this.types = 0;
        this.num = 6;
      } else if (n.length == 5) {
        this.types = 0;
        this.num = 6;
      } else if (n.length == 4) {
        this.types = 0;
        this.num = 4;
      } else if (n.length == 3) {
        this.types = 1;
        this.num = 3;
      } else if (n.length == 2) {
        this.types = 1;
        this.num = 2;
      } else if (n.length == 1) {
        this.types = -1;
        this.num = 1;
      }
      deep: true;
    },
  },
  methods: {
    turnto() {
      this.$router.push({ path: "/product" });
    },
    hover(e) {
      this.movehover = e;
    },
  },
};
</script>

<style scoped lang="less">
.total {
  .totalimg:hover {
    margin-top: -0.52vw;
  }
  .totalimg {
    .mask {
      width: 100%;
      height: 100%;
      background: rgba(3, 109, 220, 0.7);
      transition: all 1s;
      color: white;
      font-size: 1.04vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    width: 17.45vw;
    background-position: 0 0;
    background-size: 100% 100%;
    height: 10.42vw;
  }
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1.04vw;
  justify-content: center;
}
</style>
